<script>
export default {
  name: 'FieldMixin',
  props: ['value'],
  data () {
    return {
      localValue: this.value
    }
  },
  watch: {
    localValue (newValue) {
      this.$emit('update:value', newValue)
    },
    value (newValue) {
      if (newValue !== this.localValue) {
        this.localValue = newValue
      }
    }
  }
}
</script>
